<template>
  <div class="threeD-wrap">
    <div class="graph-source">
      <div class="reset">
        <span @click="back(1)">
          返回<i class="el-icon-back" style="margin-left:10px"></i>
        </span>
      </div>
      <div class="graph-source-title">图源列表</div>
      <div style="flex: 1;overflow: auto;">
        <el-collapse v-model="selectedGroupId" class="collapse-warp" accordion>
          <el-collapse-item v-for="(item,index) in defaultStore" :key="index" :title="item.name" :name="item.id">
            <div class="components-warp-content">
              <template v-for="(obj,i) in item.components">
                <div class="graph-source-item" :key="i">
                  <div :key="i" class="graph-source-img" style="text-align: left;" @click="add(obj)">
                    <img :src="obj.img" />
                  </div>
                  <label>{{obj.measureName}}</label>
                </div>
              </template>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="canvas">
      <div style="position: relative;width: 2880px;height: 1400px;">
        <img src="/img/baseNew.png" style="position: absolute;left: 0px;top: 0px;width:100%;height:100%;" />
        <vue-drag-resize v-for="(item,index) in list[0].value" :key="index" :w="item.width" :h="item.height" :x="item.x" :y="item.y" :parentLimitation="true" :isResizable="false" @clicked="dragResizeClicked(index)" @dragstop="dragstop">
          <img :src="item.img" :style="{width:item.width+'px',height:item.height+'px'}" alt />
        </vue-drag-resize>
      </div>
    </div>
    <div class="graph-source-param">
      <div v-if="selectedDragIndex !== null">
        <div class="param-item">
          <label class="title">名称：</label>
          <el-input v-model="list[0].value[selectedDragIndex].measureName" disabled></el-input>
        </div>
        <div class="param-item" v-if="list[0].value[selectedDragIndex].typeId!=''">
          <label class="title">测量点：</label>
          <el-input v-model="list[0].value[selectedDragIndex].typeId"></el-input>
        </div>
        <div class="param-item">
          <label class="title">x：</label>
          <el-input v-model="list[0].value[selectedDragIndex].x" disabled></el-input>
        </div>
        <div class="param-item">
          <label class="title">y：</label>
          <el-input v-model="list[0].value[selectedDragIndex].y" disabled></el-input>
        </div>
      </div>
      <div style="padding: 10px;">
        <el-button @click="saveSource">保存</el-button>
        <el-button @click="delDrag(selectedDragIndex)">删除</el-button>
      </div>
    </div>
  </div>
</template>
<script>
let vm
import api from '@common/api/index.js'
import VueDragResize from 'vue-drag-resize' //缩放、拖拽
import * as configData from '@/config/index.js'
import { isNull } from 'util'
export default {
  name: 'threeD',
  props: {
    rowId: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  // 引用组件
  components: { VueDragResize },
  data () {
    return {
      list: [
        { row: 0, value: [] }
      ],
      selectedDragIndex: null,
      rowIndex: 0,
      sameList: [],
      selectedGroupId: 0,
      defaultStore: window.baseConfig.assetsParam.list,
    }
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  // 实例已经创建完成之后被调用。
  created () {
    vm = this;
    vm.getData();
    console.log(vm.list)
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () { },
  // keep-alive组件激活时调用
  activated () { },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {},
  // 方法定义
  methods: {
    //获取组件内容
    getData () {
      api.customUrl.getFrontEndPageCustomParam(0, '/system/monitoringHome', null).then(res => {
        vm.list = []
        vm.sameList = JSON.parse(res.data[0].value)
        vm.sameList.forEach((item, index) => {
          if (item.rowId == vm.rowId) {
            vm.list.push(item) //每次将该rowID下面的个数还原
          }
        })
        console.log(vm.list)
      })
    },
    //获取表格数据
    add (item) {
      let wd = ''
      let isExit = false
      if (vm.list[0].value.length > 0) {
        vm.list[0].value.forEach(temp => {
          if (item.measureName != '温度柜' && item.measureName != '湿度柜' && item.measureName != '水位柜' && item.measureName != 'O3柜' && item.measureName != 'SF6柜' && item.measureName != 'O2柜') {
            wd = -1
          } else {
            wd = temp.measureName.indexOf(item.measureName)
          }
          if (wd > -1) {
            isExit = true
          } else {
            isExit = false
          }
        })
        if (isExit == false) {
          vm.list[0].value.push({
            width: item.width,
            height: item.height,
            name: item.name,
            img: item.img,
            measureName: item.measureName,
            measureId: item.measureId,
            enterImg: item.enterImg,
            x: 0,
            y: 0,
            typeId: item.typeId ? item.typeId : ''
          })
        } else {
          vm.$message({
            message: item.measureName + '只能有一个!请选择其他',
            type: 'warning'
          });
          return
        }
      } else {
        vm.list[0].value.push({
          width: item.width,
          height: item.height,
          name: item.name,
          img: item.img,
          measureName: item.measureName,
          measureId: item.measureId,
          enterImg: item.enterImg,
          x: 0,
          y: 0,
          typeId: item.typeId ? item.typeId : ''
        })
      }
      //console.log(vm.list[0].value);
    },
    delDrag (index) {
      vm.list[0].value.splice(index, 1);
      vm.selectedDragIndex = null;
    },
    dragResizeClicked (index) {
      vm.selectedDragIndex = index;
    },
    dragstop (e) {
      //console.log(e);
      //console.log(e.left);
      vm.list[0].value[vm.selectedDragIndex].x = e.left;
      vm.list[0].value[vm.selectedDragIndex].y = e.top;
    },
    saveSource () {
      for (let i = 0; i < vm.list.length; i++) {
        let item = vm.sameList.find(obj => {
          return obj.rowId == vm.list[i].rowId;
        });
        if (item) {
          item.value = vm.list[i].value;
        }
      }
      api.customUrl.setFrontEndPageCustomParam(0, '/system/monitoringHome', 'param', vm.sameList).then(res => { })
    },
    //返回
    back (type) {
      vm.$emit('back', type)
    }
  }
}
</script>
<style lang="scss" scoped>
.threeD-wrap {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
}
.graph-source {
  width: 260px;
  height: 100%;
  display: flex;
  flex-flow: column;
  background: #ffffff;
  color: #000000;
  margin-right: 20px;
  .graph-source-title {
    height: 30px;
    line-height: 30px;
    text-align: left;
    padding: 0px 10px;
    background: #ccc;
  }
  .graph-source-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    .graph-source-img {
      width: 50px;
      height: 50px;
      padding-right: 10px;
      display: inline-block;
      position: relative;
      img {
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
.canvas {
  width: calc(100% - 540px);
  height: 100%;
  background: #ffffff;
  margin-right: 20px;
  overflow: auto;
}
.graph-source-param {
  width: 260px;
  height: 100%;
  color: #000000;
  background: #ffffff;
  .param-item {
    display: flex;
    align-items: center;
    padding: 4px 6px;
    .title {
      flex: 0 0 60px;
      text-align: right;
    }
  }
}
.reset {
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 112px;
  margin: 10px auto;
  cursor: pointer;
  margin-bottom: 10px;
  font-size: 18px;
}
.collapse-warp {
  width: 100%;
}
</style>
<style lang="scss">
.threeD-wrap {
  .vdr.active:before {
    outline: none !important;
  }
}
.threeD-wrap .graph-source .graph-source-item .graph-source-img {
  width: 50px;
  height: 50px;
  padding-right: 10px;
  display: inline-block;
  position: relative;
  cursor: pointer;
}
</style>